import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { taxonomyAttributesSearchSchema } from '~/features/taxonomy-studio/utils/taxonomy-search';

const AttributesPage = lazy(() => import('~/features/taxonomy-studio/pages/attributes-page'));

/** Taxonomy Studio — attributes, their values and where they attach. */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy/attributes')({
  validateSearch: taxonomyAttributesSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AttributesPage />
    </Suspense>
  ),
});
